/**
 * RectRoundButton component, representing a button with rounded rectangle
 * shape.
 *
 * It derives from IconButton.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import IconButton, { IconButtonProps } from './IconButton'
import './RectRoundButton.css'

const RectRoundButton = (props: IconButtonProps) => (
  <IconButton
    {...props}
    className={`rect-round-button ${props.className ?? ''}`}
  />
)

export default RectRoundButton
